import React from "react";
import { Tab, Tabs } from "react-bootstrap";
const GenericTabs = (props) => {
    const onSelectAction = (selected) => {
        if (props.callBackFunction)
            props === null || props === void 0 ? void 0 : props.callBackFunction(selected);
    };
    return (React.createElement("div", { className: `generic-tabs ${props.externalClassName ? props.externalClassName : ""}` },
        React.createElement(Tabs, { defaultActiveKey: props.defaultActiveKey, onSelect: onSelectAction, className: props === null || props === void 0 ? void 0 : props.TabsClassName, activeKey: props.activeKey }, props.tabsArray &&
            props.tabsArray.map((tab, idx) => {
                return (React.createElement(Tab, { title: React.createElement(React.Fragment, null,
                        tab.title,
                        tab.suffix ? props.suffixComp : ""), eventKey: tab.eventKey, disabled: tab.disabled, key: idx }, (props.activeKey === tab.eventKey ||
                    props.defaultActiveKey === tab.eventKey) &&
                    tab.tabContent));
            }))));
};
export default GenericTabs;
